import { type TypedDocumentNode, gql } from '@apollo/client';
import type {
  ActionPerformedMutation,
  ActionPerformedMutationVariables,
  LoginActionPerformedMutation,
  LoginActionPerformedMutationVariables,
  SetMissionLikeMutation,
  SetMissionLikeMutationVariables,
} from '../../models/__generated__/graphql';

export const ACTION_PERFORMED: TypedDocumentNode<
  ActionPerformedMutation,
  ActionPerformedMutationVariables
> = gql`
  mutation ActionPerformed($url: String!, $action: String!) {
    urlActionPerformed(url: $url, action: $action) {
      eventId
      success
    }
  }
`;

export const LOGIN_ACTION: TypedDocumentNode<
  LoginActionPerformedMutation,
  LoginActionPerformedMutationVariables
> = gql`
  mutation LoginActionPerformed {
    loginActionPerformed {
      __typename
      ... on LoginActionSuccess {
        eventId
      }
      ... on ActionRateExceeded {
        message
      }
      ... on BasicError {
        message
      }
      ... on WrongPermissions {
        message
      }
    }
  }
`;

export const SET_MISSION_LIKE: TypedDocumentNode<
  SetMissionLikeMutation,
  SetMissionLikeMutationVariables
> = gql`
  mutation SetMissionLike($missionId: ID!, $iLike: Boolean!) {
    updateMissionLike(missionId: $missionId, iLike: $iLike) {
      id
      iLike
      totalLikes
    }
  }
`;
